'use client';

import { GiftcardsErrorPage } from 'components';
import { ZmyleErrorId } from 'utils/constants';
import { formatDateAsZmyleApi } from 'utils/helpers';

const internalServerError: ZmyleError = {
  errorId: ZmyleErrorId.INTERNAL_SERVER_ERROR,
  errorMsg: 'Internal server error',
  occurredAt: formatDateAsZmyleApi(new Date()),
  status: 500,
};

export function Error() {
  return <GiftcardsErrorPage error={internalServerError} />;
}
